import { AllInGenderGroup } from 'Store/profile/types';

import {
  NAVIGATION_BUTTON_PURPOSE_BACK,
  NAVIGATION_BUTTON_PURPOSE_CLOSE,
  NavigationButtonPurpose,
} from 'Components/CloseX';

import { AllInDialogContext } from '../allInDialog.type';

export const closeButtonPurpose = (componentContext: AllInDialogContext): NavigationButtonPurpose =>
  componentContext === 'selection'
    ? NAVIGATION_BUTTON_PURPOSE_CLOSE
    : NAVIGATION_BUTTON_PURPOSE_BACK;
export const closeButtonPosition = (componentContext: AllInDialogContext) =>
  componentContext === 'selection' ? 'right' : 'left';

/**
 * Parse values from allInGender accordingly for all inclusive analytics.
 * @param allInGender
 * @returns genders ids separated by comma
 */
export const parseAllInGenderToSparks = (allInGender: AllInGenderGroup[]): string => {
  const gendersSelected = new Set<string>();
  allInGender.forEach((gender) => {
    if (gender.checked) {
      gendersSelected.add(gender.id);
      gender.children?.forEach((child) => {
        if (child.checked) {
          gendersSelected.add(child.id);
        }
      });
    }
  });
  return [...gendersSelected].join(',');
};

/**
 * Parse values from displayGenders/displayOrientations accordingly for all inclusive analytics.
 * @param displayOptions
 * @returns gender ids separated by comma
 */
export const parseAllInDisplayOptions = (displayOptions: string[] | null) =>
  displayOptions?.join(',') ?? '';
